/**
 * Quick period buttons for the reports page (YYYY-MM-DD, local time).
 */
import moment from 'moment';

export interface PeriodPreset {
  key: 'today' | 'yesterday' | 'last7' | 'thisMonth' | 'lastMonth' | 'thisYear' | 'allTime';
  from: string;
  to: string;
}

const fmt = (m: moment.Moment) => m.format('YYYY-MM-DD');

export const periodPresets = (): PeriodPreset[] => {
  const today = moment();
  const lastMonth = moment().subtract(1, 'month');
  return [
    { key: 'today', from: fmt(today), to: fmt(today) },
    { key: 'yesterday', from: fmt(moment().subtract(1, 'day')), to: fmt(moment().subtract(1, 'day')) },
    { key: 'last7', from: fmt(moment().subtract(6, 'days')), to: fmt(today) },
    { key: 'thisMonth', from: fmt(moment().startOf('month')), to: fmt(today) },
    { key: 'lastMonth', from: fmt(lastMonth.clone().startOf('month')), to: fmt(lastMonth.clone().endOf('month')) },
    { key: 'thisYear', from: fmt(moment().startOf('year')), to: fmt(today) },
    { key: 'allTime', from: '', to: '' },
  ];
};
